/* Fetches the related-products section back with recommendations populated.
   Shopify's two-pass pattern: the first render has no products, this asks
   for the same section again via the recommendations endpoint. */
(function () {
  'use strict';

  var placeholder = document.querySelector('[data-wr-related]');
  if (!placeholder || !placeholder.dataset.url) return;

  fetch(placeholder.dataset.url)
    .then(function (r) {
      if (!r.ok) throw new Error('recommendations unavailable');
      return r.text();
    })
    .then(function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var section = parsed.querySelector('.wr-related-section');
      if (section) placeholder.replaceWith(section);
    })
    .catch(function () {
      // No recommendations is not an error state — the page is complete
      // without them, so the placeholder just stays hidden.
    });
})();
